"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.GroupInvitationLink = void 0;

var _preact = require("preact");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _globals = _interopRequireDefault(require("@insided/shared/utils/globals"));

var _service = require("./service");

var _InputGroup = _interopRequireDefault(require("@insided/shared/uikit/InputGroup"));

var _buttonControl = _interopRequireDefault(require("@insided/deprecated-preact-components/button-control"));

var _clipboard = _interopRequireDefault(require("@insided/deprecated-utils/clipboard"));

var _dropdown = _interopRequireDefault(require("@insided/shared/uikit/dropdown"));

var _ArrowDropdown = _interopRequireDefault(require("@insided/destination/icons/ArrowDropdown"));

var _utils = require("@insided/shared/Groups/utils");

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var GroupInvitationLink = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(GroupInvitationLink, _Component);

  var _super = _createSuper(GroupInvitationLink);

  function GroupInvitationLink() {
    var _this;

    (0, _classCallCheck2.default)(this, GroupInvitationLink);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      inviteToken: '',
      expiry: _utils.ExpiryTypes.days90,
      isGeneratingInviteToken: false
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "expiryPeriods", (0, _utils.getExpiryPeriods)(_this.props.communityLocale.replace('_', '-')));
    return _this;
  }

  (0, _createClass2.default)(GroupInvitationLink, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.fetchInviteToken();

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "fetchInviteToken",
    value: function () {
      var _fetchInviteToken = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2() {
        var expiry, token;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                expiry = this.state.expiry;
                this.setState({
                  isGeneratingInviteToken: true
                });
                _context2.prev = 2;
                _context2.next = 5;
                return (0, _service.generateInviteToken)({
                  groupId: this.props.groupId,
                  expiry: expiry
                });

              case 5:
                token = _context2.sent;
                this.setState({
                  inviteToken: token,
                  isGeneratingInviteToken: false
                });
                _context2.next = 13;
                break;

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](2);
                this.setState({
                  isGeneratingInviteToken: false
                }); // eslint-disable-next-line no-console

                console.log('error: ', _context2.t0);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 9]]);
      }));

      function fetchInviteToken() {
        return _fetchInviteToken.apply(this, arguments);
      }

      return fetchInviteToken;
    }()
  }, {
    key: "onExpiryChange",
    value: function onExpiryChange(expiry) {
      var _this2 = this;

      this.setState({
        expiry: expiry
      }, function () {
        _this2.fetchInviteToken();
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$state = this.state,
          inviteToken = _this$state.inviteToken,
          expiry = _this$state.expiry,
          isGeneratingInviteToken = _this$state.isGeneratingInviteToken;
      var groupId = this.props.groupId;
      var inviteLink = "".concat((0, _globals.default)('communityUrl'), "/groups/").concat(groupId, "?invite=").concat(encodeURIComponent(inviteToken));

      if (!inviteToken) {
        return null;
      }

      return (0, _preact.h)("div", {
        className: "add-members-modal_invite-link-wrapper"
      }, (0, _preact.h)(_InputGroup.default, {
        newStyle: true,
        title: "Add members using an invite link",
        meta: (0, _preact.h)(_phrase.default, {
          p: "groups.add.members.invite.link.description.common"
        }),
        formGroupClasses: "add-members-modal_invite-link-label",
        customInput: (0, _preact.h)("div", null, (0, _preact.h)("div", {
          className: "add-members-modal_expiry-wrapper"
        }, (0, _preact.h)("div", {
          className: "add-members-modal_expiry-title"
        }, (0, _preact.h)(_phrase.default, {
          p: "groups.add.members.invite.link.expiry"
        })), (0, _preact.h)(_dropdown.default, {
          closeOnDropdownClick: true,
          popupName: "expiry-selector",
          className: "dropdown-selector expiry-selector",
          trigger: (0, _preact.h)("div", null, this.expiryPeriods[expiry], (0, _preact.h)(_ArrowDropdown.default, null)),
          triggerClass: "dropdown-selector-wrapper--destination"
        }, Object.values(_utils.ExpiryTypes).map(function (expiry) {
          return (0, _preact.h)("button", {
            role: "button",
            tabIndex: 0,
            key: expiry,
            className: "dropdown--expiry-option",
            onClick: function onClick() {
              return _this3.onExpiryChange(expiry);
            }
          }, _this3.expiryPeriods[expiry]);
        }))), (0, _preact.h)("div", {
          className: "add-members-modal_invite-link-input"
        }, (0, _preact.h)("input", {
          className: "form-control qa-group-invite-link",
          value: inviteLink,
          disabled: true
        }), (0, _preact.h)(_buttonControl.default, {
          isLoading: isGeneratingInviteToken,
          newStyle: true,
          size: "medium",
          variant: "brand",
          title: "Copy",
          onClick: /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3() {
            var _this3$props$showMess, _this3$props;

            return _regenerator.default.wrap(function _callee3$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return (0, _clipboard.default)(inviteLink);

                  case 2:
                    (_this3$props$showMess = (_this3$props = _this3.props).showMessage) === null || _this3$props$showMess === void 0 ? void 0 : _this3$props$showMess.call(_this3$props, 'success', (0, _preact.h)(_phrase.default, {
                      p: "groups.add.members.invite.link.copied"
                    }));

                  case 3:
                  case "end":
                    return _context3.stop();
                }
              }
            }, _callee3);
          })),
          className: "qa-copy-link add-members-modal_invite-link-button"
        })))
      }));
    }
  }]);
  return GroupInvitationLink;
}(_preact.Component);

exports.GroupInvitationLink = GroupInvitationLink;
var _default = GroupInvitationLink;
exports.default = _default;